import React from 'react'

const serviceData = {
  hero: {
     heading: <>WEB DESIGN &<br/> DEVELOPMENT</>,
  },
  section1: {
    description:
      <>Website building is one of the most critical investments for any modern business—a gateway to credibility, growth, and customer engagement. Building a professional and effective website is crucial in today’s digital landscape, as it serves as the cornerstone of your online presence, acting as your digital storefront, marketing tool, and customer engagement platform all in one. <br/>A well-designed website not only enhances your brand’s credibility but also provides an accessible platform for your audience to learn about your products, services, and values. In a competitive market, a website is often the first impression potential clients or customers have of your business; therefore, investing in quality website development is essential for establishing trust, attracting leads, and driving conversions</>,
      title1: "Why Website Building Is Important",
      description1: 'A professionally built website is the digital storefront for your brand, open 24/7 to anyone worldwide. The best global agencies agree on these core benefits',
    image: "/webimg1.webp",
  points: [
      {
        head: "Credibility & Trust",
        text: "A high-quality website assures customers your business is legitimate and professional. Prospects can research products, read customer testimonials, and verify credentials before making decisions.",
      },
      {
        head: "First Impressions Matter",
        text: "People judge your business based on website aesthetics and usability. Sleek design, fast load times, clear navigation, and engaging visuals—all proven on world-class sites—instantly build a positive impression.",
      },
      {
        head: "Customer Convenience",
        text: "Customers expect easy access to information, support, and shopping. A robust website means your business is always available—unlike social profiles that can be restrictive or unreliable.",
      },
      {
        head: "Marketing Engine",
        text: "Websites centralize digital marketing channels—SEO, Google Ads, social media, video, email, and analytics converge here. It’s the hub that all campaigns fuel to drive traffic, conversions, and customer loyalty.",
      },
      {
        head: "Scalability & Control",
        text: "As your business grows, your website grows with you. Add e-commerce, booking, chatbots, blog content, and more as needed—putting expansion under your control.",
      },
    ],
  },
}

const WebDevelopment = () => {
  return (
    <>
      {/* Hero Section */}
      <div className="services-hero">
        <div className='webdev-hero-img'>
          <div className="overlay"></div>
          <div className="hero-content">
            <h2 className="hero_heading">{serviceData.hero.heading}</h2>
          </div>
        </div>
      </div>

      {/* First Content Section */}
      <div className="backdiv">
      
        <div className="servicepage_grid">
        <div>
  <p className='main_content'>{serviceData.section1.description}</p>
        </div>
          <div>
            <div className="servicepage_imgdiv">
              <img
                src={serviceData.section1.image}
                alt="Web Development"
                className="zweedo_img"
                loading="lazy"
              />
            </div>
          </div>

        </div>
          <div>
             <h2 className='main_heading'>{serviceData.section1.title1}</h2>
             
            <div className="servicepage_textdiv">
              {serviceData.section1.points.map((point, index) => (
                  <div key={index} className="service_point">
                    <h4 className="point_head">{point.head}</h4>
                    <p className="point_text">{point.text}</p>
                  </div>
                ))}
            </div>
          </div>
      </div>
    </>
  )
}

export default WebDevelopment
